import { fromEvent, Subscription } from 'rxjs'
import { FromEventTarget } from 'rxjs/internal/observable/fromEvent'

let events: Subscription[] = []

export const getEvents = () => events

export const clearEvents = () => {
	for (let i = 0, { length } = events; i < length; i++) {
		events[i].unsubscribe()
	}
	events = []
}

export const useEvent = <N>(target: FromEventTarget<N>, eventName: string, ajaxIgnore = false) => {
	const newEvent = fromEvent(target, eventName)

	const register = (next: (e: N) => void) => {
		if (ajaxIgnore) {
			newEvent.subscribe(next)
			return
		}
		events.push(newEvent.subscribe(next))
	}

	return {
		register,
	}
}
